import { Text, tokens } from "@fluentui/react-components";
import React from "react";
import { rootUseStyles } from "../../taskpane/fluent-style";
import { threatConfig, ThreatType } from "../threat/threat.config";


type ThreatBoxIndicatorProps = {
    label: string;
    value: number | string;
};

export default function ThreatBoxIndicator({ label, value }: ThreatBoxIndicatorProps) {
    const styles = rootUseStyles();
    const color = threatConfig?.[label as ThreatType].color || "#616161";

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: "5px",
                width: "100%",
                height: "60px",
                border: `1px solid ${tokens.colorNeutralStroke2}`,
                borderRadius: "8px",
                padding: "2px",
            }}
        >
            <Text as="p" style={{ fontSize: "12px" }} className={styles.paragraph}>
                {label.charAt(0).toUpperCase() + label.slice(1)}
            </Text>
            <Text as="p" style={{ color }} weight="bold" className={styles.paragraph}>
                {value}
            </Text>
        </div>
    );
}
